
export function initFacebookAnalytics(userId) {
  if (!window.fbq || !userId) {
    return;
  }

  window.fbq('init', '1528180367246686', {
    external_id: userId,
  });
}

export function pushEventToFacebookAnalyticsWithParams(event, eventParams, additionalParams = null) {
  if (!window.fbq) {
    return;
  }

  if (additionalParams) {
    window.fbq('track', event, eventParams, additionalParams);
  }

  window.fbq('track', event, eventParams);
}

export function pushEventToFacebookAnalytics(event) {
  if (!window.fbq) {
    return;
  }

  window.fbq('track', event);
}

